


export const am4DateAxisGroupingMixin = {
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {
        am4DateAxisGetIntervals(groupCount, startDate, endDate, ratioUsed = 1) {
            let delta = (endDate.getTime() - startDate.getTime()) / 1000
            let deltaRatio = delta / groupCount * ratioUsed
            let intervals = {
                1: { timeUnit: "second", count: 1 },
                5: { timeUnit: "second", count: 5 },
                15: { timeUnit: "second", count: 15 },
                30: { timeUnit: "second", count: 30 },
                60: { timeUnit: "minute", count: 1 },
                300: { timeUnit: "minute", count: 5 },
                600: { timeUnit: "minute", count: 10 },
                900: { timeUnit: "minute", count: 15 },
                1800: { timeUnit: "minute", count: 30 },
                3600: { timeUnit: "hour", count: 1 },
                14400: { timeUnit: "hour", count: 4 },
                86400: { timeUnit: "day", count: 1 },
                604800: { timeUnit: "week", count: 1 },
                1209600: { timeUnit: "week", count: 2 },
                2628000: { timeUnit: "month", count: 1 },
                10512000: { timeUnit: "month", count: 4 },
                15768000: { timeUnit: "month", count: 6 },
                31536000: { timeUnit: "year", count: 1 },
            }
            let desiredIntervalSeconds = null
            let intervalIndex = 0
            Object.keys(intervals).forEach((numSeconds, index) => {
                if (_.isNil(desiredIntervalSeconds) && deltaRatio < numSeconds) {
                    desiredIntervalSeconds = numSeconds
                    intervalIndex = index
                }
            })
            return [
                intervals[desiredIntervalSeconds],
            ]
        },
    },
}